import { useEffect } from "react";

import { useDispatch, useSelector } from "react-redux";

import { RootState } from "../../app/rootReducer";
import { getDocumentTypes } from "../../slices/codeBookSlice";

export const useGetDocumentTypes = () => {
  const documentTypes = useSelector(
    (state: RootState) => state.codeBook.documentTypes
  );

  const dispatch = useDispatch();

  useEffect(() => {
    dispatch(getDocumentTypes());
  }, [dispatch]);

  return documentTypes;
};
